/** Keep in sync with server/utils/stockBuyRecRefreshPolicy.js */
export const BUY_REC_REFRESH_MIN_INTERVAL_HOURS = 4;
export const BUY_REC_REFRESH_MIN_INTERVAL_MS = BUY_REC_REFRESH_MIN_INTERVAL_HOURS * 60 * 60 * 1000;

/**
 * @param {string|Date|null|undefined} yahooLastRefreshedAt
 * @param {number} [nowMs]
 */
export function isBuyRecFilterRefreshStale(yahooLastRefreshedAt, nowMs = Date.now()) {
  if (yahooLastRefreshedAt == null || yahooLastRefreshedAt === "") return true;
  const t = new Date(yahooLastRefreshedAt).getTime();
  if (!Number.isFinite(t)) return true;
  return nowMs - t >= BUY_REC_REFRESH_MIN_INTERVAL_MS;
}

/**
 * @param {Array<{ id?: string, name?: string, yahooLastRefreshedAt?: string|null }>} filters
 * @param {number} [nowMs]
 */
export function partitionBuyRecFiltersForRefresh(filters, nowMs = Date.now()) {
  const toRefresh = [];
  const skipped = [];
  for (const filter of filters || []) {
    if (isBuyRecFilterRefreshStale(filter.yahooLastRefreshedAt, nowMs)) {
      toRefresh.push(filter);
    } else {
      skipped.push(filter);
    }
  }
  return { toRefresh, skipped };
}
